<template>
    <v-container>
        <v-row justify="center" class="mb-10">
            <v-col cols="12" sm="10" md="7" lg="5">
                <TopBar backPage="splash" hideHeader/>

                <v-divider class=""></v-divider>

                <!-- Tabs -->
                <v-tabs v-model="tab" background-color="white" grow class="my-1">
                    <v-tab value="services">{{ $t('booking.tabs.services') }}</v-tab>
                    <v-tab v-if="$t('booking.tabs.faqs') != ' ' && !!$store.state.info.faqs && $store.state.info.faqs != null && $store.state.info.faqs.length > 0" value="faqs">{{ $t('booking.tabs.faqs') }}</v-tab>
                    <v-tab v-if="$t('booking.tabs.portfolio') != ' ' && !!$store.state.info.gallery && $store.state.info.gallery != null && $store.state.info.gallery.length > 0" value="gallery">{{ $t('booking.tabs.portfolio') }}</v-tab>
                    <v-tab value="about">{{ $t('booking.tabs.about') }}</v-tab>
                    <v-tab v-if="$store.getters.hasBlogAccess && $t('booking.tabs.blog') != ' '" value="blog">{{ $t('booking.tabs.blog') }}</v-tab>
                </v-tabs>

                <v-tabs-window v-model="tab">
                    <v-tabs-window-item value="services">
                        <v-row class="pa-2"
                            v-if="!!$store.state.info.serives_cats && $store.state.info.serives_cats.length > 0">
                            <v-slide-group
                                v-model="selectedCategory"
                                class="py-1 ma-1 global-card-background"
                                center-active
                                show-arrows
                                style="border-radius: 10px;width: 100%;"
                                >
                                <!-- <v-slide-group-item
                                    value="all"
                                    v-slot="{ isSelected, toggle }"
                                >
                                    <v-card
                                    :color="isSelected ? '' : 'info'"
                                        :class="isSelected ? 'border-lg border-current' : 'border-grey'"
                                    class="ma-1"
                                    height="90"
                                    width="80"
                                    variant="tonal"
                                    rounded
                                    @click="toggle"
                                    >
                                    <div class="d-flex flex-column fill-height align-center justify-center">
                                        <img 
                                            v-if="!!$store.state.info.form_icon && $store.state.info.form_icon.length > 5" 
                                            :src="$store.state.fileBaseUrl+$store.state.info.form_icon" 
                                            class="cat-image" />
                                        
                                        <img v-else
                                        class="cat-image"
                                            :src="require('../assets/logo.svg')"  />
                                        <div class="mt-2">
                                            {{ $t('booking.all_categories') }}
                                        </div>
                                    </div>
                                    </v-card>
                                </v-slide-group-item> -->
                                <v-slide-group-item
                                    v-for="(cat, index) in $store.state.info.serives_cats.filter(c => c.count > 0)"
                                    :key="index"
                                    :value="cat.id"
                                    v-slot="{ isSelected, toggle }" >
                                    <v-card
                                        :color="isSelected ? '' : ''"
                                        :class="isSelected ? 'border-lg border-current' : 'border-grey'"
                                        class="ma-1"
                                        height="80"
                                        width="70"
                                        variant=""
                                        rounded
                                        @click="toggle"
                                        >
                                        <div class="d-flex flex-column fill-height align-center justify-center">
                                            <img class="cat-image" :src="$store.state.fileBaseUrl+'/img/options_icons/'+cat.icon"/>
                                            <div class="mt-2 info" style="font-size: 10px !important;">  
                                                {{ cat.title }}
                                            </div>
                                        </div>
                                    </v-card>
                                </v-slide-group-item>
                            </v-slide-group>
                        </v-row>
                        <v-row class="mt-1" v-if="!!$store.state.info.serives && $store.state.info.serives.length > 0">
                            <v-col cols="12" class="px-3"
                                v-for="(service, index) in $store.state.info.serives.filter(s => !s.just_addon && (s.cat == selectedCategory || selectedCategory == 'all' || selectedCategory == null))"
                                :key="index">
                                <v-card class="pa-4 global-card-background" elevation="3" rounded="lg">
                                    <div class="d-flex flex-column">
                                        <div class="d-flex justify-space-between">
                                            <div style="flex-grow: 1;" class="pl-3">
                                                <h4>{{ service.title }}</h4>
                                                <p class="text-body-2">
                                                    {{ service.description }}
                                                </p>
                                            </div>
                                            <ZoomableImage v-if="service.image.length > 0" img-class="service-img" :src="$store.state.fileBaseUrl+service.image" :alt="service.title"/>
                                        </div>
                                        <div class="d-flex justify-space-between align-center mt-2">
                                            <div>
                                                <template v-if="service.has_variable && !!service.options && !!service.options.varibles && service.options.varibles.length > 0">
                                                    <strong>{{ new Intl.NumberFormat('fa-IR').format(service.options.varibles[0].price) }}</strong>
                                                </template>
                                                <strong v-else>{{ new Intl.NumberFormat('fa-IR').format(service.price) }}</strong>
                                                <span class="text-caption mr-1">
                                                    {{ $t('rial') }}
                                                </span>
                                            </div>
                                            <template v-if="checkServiceIsInCart(service)">
                                                <TotalControl
                                                    @decrease="$store.commit('decreaseService', serviceIsInCart(service))"
                                                    @increase="$store.commit('increaseService', serviceIsInCart(service))"
                                                    @remove="$store.commit('removeService', serviceIsInCart(service))"
                                                    :item="serviceIsInCart(service)"/>
                                            </template>
                                            <v-btn
                                                v-else
                                                :disabled="service.total == 0"
                                                @click="$store.commit('setService', {service:service});"
                                                class="global-card-background"
                                                 rounded="lg">
                                                {{ $t('booking.reserve_button') }}
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="faqs">
                        <Faqs v-if="!!$store.state.info.faqs && $store.state.info.faqs != null && $store.state.info.faqs.length > 0"/>
                    </v-tabs-window-item>
                    <v-tabs-window-item value="gallery">
                        <Gallery v-if="!!$store.state.info.gallery && $store.state.info.gallery != null && $store.state.info.gallery.length > 0"/>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="about">
                        <BusinessCardList v-if="!!$store.state.info.metas && $store.state.info.metas != null && $store.state.info.metas.length > 0"/>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="blog">
                        <BlogPanel v-if="$store.getters.hasBlogAccess" />
                    </v-tabs-window-item>

                    <v-tabs-window-item value="comments">
                        <p>{{ $t('booking.comments_section') }}</p>
                    </v-tabs-window-item>
                </v-tabs-window>
            </v-col>
        </v-row>
    <BottomBar v-if=" $store.state.cart.length > 0 "/>
    </v-container>
</template>

<script>
    import TopBar from '@/components/top_bar.vue';
    import BusinessCardList from '@/components/BusinessCardList.vue';
    import BottomBar from '@/components/bottom_bar.vue';
    import TotalControl from '@/components/total_control.vue';
    import Faqs from '@/components/faqs.vue';
    import Gallery from '@/components/gallery.vue';
    import BlogPanel from '@/components/BlogPanel.vue';
    import ZoomableImage from '@/components/ZoomableImage.vue';

    export default {
        name: "BookingPage",
        components: {
            TopBar,
            BusinessCardList,
            BottomBar,
            TotalControl,
            Faqs,
            Gallery,
            BlogPanel,
            ZoomableImage,
        },
        data() {
            return {
                tab: "services",
                selectedCategory: "all",
            };
        },
        methods:{
            checkServiceIsInCart(service){
                if(service.has_variable){ //چو
                    return false;
                }
                if(!!service.options && !!service.options.addons && service.options.addons.length > 0){
                    return false;
                }
                if(this.$store.state.cart.length == 0){
                    return false;
                }
                if(this.$store.state.cart.filter(e=>e.id == service.id).length == 0){
                    return false;
                }
                return true;
            },
            serviceIsInCart(service){
                return this.$store.state.cart.find(e=>e.id == service.id);
            },
        },
    };
</script>

<style>
    .text-center {
        text-align: center;
    }
    .business-card-list-item-text a, a:visited, a:hover, a:active, a:focus {
        color: black !important;
        text-decoration: none !important;
    }


    .service-img {
        border-radius: 10px;
        transition: all .2s;
        width: 120px;
        height: 120px;
        object-fit: cover;
    }
    .cat-image {
        border-radius: 10px;
        transition: all .2s;
        width: 50px;
        height: 50px;
        object-fit: cover;
    }
    .v-slide-group__content{
        justify-content: center;
    }
</style>